class HomepageSlideshow extends ViewBasic {
    constructor(options) {

        let defaults = {
        }

        super(options, defaults);
    }

    init() {
        this.interval = setInterval(this.nextSlide, 4000);
        this.$('.slideshow-ctn .hero-bg:eq(0)').addClass('active');
    }

    addDispatchListener() {
        super.addDispatchListener();
    }

    removeEvents() {

    }

    nextSlide(){
        //first element has a first class to animate itself without the need of js and reduce delays in animations
        this.$('.slideshow-ctn .hero-bg.first').removeClass('first');

        var currentIndex = (this.$('.slideshow-ctn .hero-bg.active').index() + 1);

        //reset index when we reach end of array
        if(currentIndex >= this.$('.slideshow-ctn .hero-bg').length){
            currentIndex = 0;
        }

        //remove previously active element classes
        this.$('.slideshow-ctn .hero-bg.previous-active').removeClass('previous-active');
        this.$('.slideshow-ctn .hero-bg.active').removeClass('active').addClass('previous-active');

        //then animate new active slide
        this.$('.slideshow-ctn .hero-bg:eq(' + currentIndex + ')').addClass('active');
    }
}